// Wraps a table in a div with an overflow to make it "responsive"

export default () => {
  var tables = document.getElementsByTagName('table');

  for (var i = 0; i < tables.length; i++) {
    var table = tables[i];
    console.log(table);

    var parent = table.parentNode;
    var wrapper = document.createElement('div');
    wrapper.style.overflowX = 'scroll';
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
};
